import withList from '../../with-list/main';
import { selectors, actions } from './';
import table from './table-initial-data';

export default withList(selectors, actions, table, {
	link: '/banners/contents/editor',
	text: 'Create banner content'
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/content/list/main.js